module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/4f78e2dbcd0ec251293e5a21bf3bec67.svg";